import { Container } from "react-bootstrap";

const TermCondition = () => {
  return (
    <>
      <section className="common-area">
        <Container>
          <div className="term-condition-area">
            <h4 className="title">
              UNION APP RIDER/DRIVER TERMS AND CONDITIONS
            </h4>
            <p>
              <b>
                PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE
                SERVICES.
              </b>
            </p>
            {/* terms and conditions table view */}
            <h5 className="sub-title">BACKGROUND</h5>
            <p>
              These Terms of Use, together with any and all other documents
              referred to herein, set out the terms of use under which you may
              use this Application, (“Our Application”). You must read, agree
              and accept all the Terms set out in this agreement, including the
              terms and conditions set out below. You will be required to read
              and accept these Terms of Use when signing up for an Account. If
              you do not accept all the terms of this agreement, then Union App
              is unwilling to allow you to use the Union App platform. By using
              any of the services you become a Service Provider on the Union App
              platform and you agree to be bound by the terms and conditions of
              this agreement with respect to the provision of such services. If
              you do not agree to be bound by the terms of this agreement, do
              not use the Union App. We may amend these Terms at any time by
              posting the amended terms on the Union App. You may not have
              access to the Union App before accepting these terms. These Terms
              of Use do not apply to the sale of services.
            </p>
            <h6 className="sub-to-sub-title">
              1. Definitions and Interpretation
            </h6>
            <p>
              In these Terms of Use, unless the context otherwise requires, the
              following expressions have the following meanings:
            </p>
            <ul className="under-list">
              <li>
                <b>“Account”</b> - means an account required for a Driver to
                access and/or use certain areas of Application, as detailed in
                Clause 4;
              </li>
              <li>
                <b>“Content”</b> - means any and all text, images, audio, video,
                scripts, code, software, databases, and any other form of
                information capable of being stored on a computer that appears
                on, or forms part of, Our Site;
              </li>
              <li>
                <b>“Driver”</b> - means an independent business person operating
                as a vehicle/ as a two-wheel transportation provider for people
                or goods. This term shall be used to mean either a “Union App
                Driver ” or “Union App Rider” interchangeably as the context may
                require.
              </li>
              <li>
                <b>“Owner”</b> - means those who make their vehicle(s) available
                for others to use through our application.
              </li>
              <li>
                <b>“Union Boda”</b> - means all versions of the Union Apps.
              </li>
              <li>
                <b>“Union App Driver ” or “Union App Rider”</b> - means a
                driver/rider who has successfully completed all the necessary
                steps to register on the Union App and has subsequently been
                provided with an Account.
              </li>
              <li>
                <b>“Union Wallet Balance”</b> - means the balance of earnings
                due to a Driver as the result of services provided to Users
                through the Union applications.
              </li>
              <li>
                <b>“Union App Support Desk”</b> - means the in-person support
                and the call center available to all current and prospective
                Drivers in the various locations where Union App is operational.
              </li>
              <li>
                <b>“Service Provider”</b> - means any individual or business,
                including Riders/Drivers, that offers goods or services to
                Customers/Users on the Union App platform.
              </li>
              <li>
                <b>“User”</b> - means a user or consumer of any Union Apps
                and/or a beneficiary to Services extended through our
                Application.
              </li>
              <li>
                <b>“User Content”</b> - means any content submitted to Our
                Application by Users including, but not limited to include
                personal information, images, and all data.
              </li>
              <li>
                <b>“We/Us/Our”</b> - means all licensees of the Union Apps.
              </li>
            </ul>
            <p>
              <b>Information About Us</b> - More information about Union App is
              available at our website - www.unionmobilityapp.com, or on request
              by emailing support@unionmobilityapp.com{" "}
            </p>
            <h6 className="sub-to-sub-title">2. Our Application</h6>
            <ul className="under-list no-order">
              <li>
                2.1. Any Driver seeking to become a Driver must undergo an
                onboarding process and succeed in passing all the necessary
                requirements, including but not limited to; - satisfactory
                completion of background checks, completion of training, and
                verification of vehicle, only then are Drivers allowed to access
                our Application.
              </li>
              <li>
                2.2. We reserve the right to discontinue, stop or preclude
                anyone from accessing our Application at any time and for any
                period. Will not be liable to you in any way if such access is
                made unavailable to you at any time.
              </li>
              <li>
                2.3. It is the responsibility of the Driver to make any and all
                arrangements necessary in order to access Our Application. Any
                Driver who is unable to access the Application should contact us
                for clarification and guidance.
              </li>
              <li>
                2.4. Access to Our Application is provided “as is” and on an “as
                available” basis. We may alter, suspend or discontinue Our
                Application (or any part of it) at any time and without notice.
                We will not be liable to you in any way if Our Application (or
                any part of it) is unavailable at any time and for any period.‍
              </li>
            </ul>
            <h6 className="sub-to-sub-title">3. Terms of Use</h6>
            <ul className="under-list no-order">
              <li>
                3.1. Drivers remain fully independent business people. The Union
                App is a mechanism for a Driver to connect with Users, to whom
                they may wish to provide Services.
              </li>
              <li>
                3.2. Neither the provision of access to the Union App nor any
                other action by Union App constitutes an employment agreement or
                contract for services.
              </li>
              <li>
                3.3. We have no responsibility whatsoever for the actions or
                conduct of any service providers or Users. We have no obligation
                to intervene in any way in disputes that may arise between
                drivers, riders, or third parties. Responsibility for the
                decisions made regarding providing or accepting transportation
                rests solely with the User and the Driver.
              </li>
              <li>
                3.4. We will not be liable for any damages, direct, incidental,
                and or consequential, arising out of the use of Union Boda,
                including, without limitation, damages arising out of
                communicating and or meeting with other participants of Union
                Boda, or introduced to you via Union Boda. Such damages include
                and are not limited to, physical damages, bodily injuries,
                death, and emotional distress and discomfort.
              </li>
              <li>
                3.5. Drivers shall take reasonable precautions in all actions
                and interactions with any party they may interact with through
                the use of the services. Union App has no control over the
                identity or actions of the users and service providers and Union
                App requests that users exercise caution and good judgment when
                using the services. Service providers and users use the services
                at their own risk.
              </li>
              <li>
                3.6. Drivers are required to adhere to the Union App Code of
                Conduct when using the Application. The Recommended Standards of
                Service will be provided to the Union App driver during the
                onboarding process and will be updated from time to time. It is
                the responsibility of the Union App driver to ensure that they
                are familiar with the latest version of the Recommended
                Standards of Service.
              </li>
              <li>
                3.7. The Union App provides fair and transparent prices for both
                Drivers and Users. Drivers agree to adhere to the pricing set
                out by the Union App. Any Union App Driver or user wishing to
                understand the way in which the Union App calculates prices or
                who believes there has been an error in pricing should contact
                the Union App service desk and provide full details.
              </li>
              <li>
                3.8. Union App may from time to time offer incentives to Drivers
                at the company’s discretion and equally reserves the right to
                make deductions from Driver's earnings in line with these terms
                of use.
              </li>
              <li>
                3.10. All programs for Incentives or Sanctions may be
                communicated to Drivers by Us through SMS, in-app notifications,
                announcements, and posters at the Union App premises. It is,
                therefore, the responsibility of the Driver to clearly monitor
                all communications and ensure that they are aware of any changes
                in the program of Incentives and Sanctions.
              </li>
              <li>
                3.11. We reserve the right to charge a commission or other
                service fee from Drivers for access to or for services provided
                to users through the Union App platform. Such charges will be
                communicated to Drivers in advance. It is the responsibility of
                the Driver to clearly monitor all communications and ensure that
                they are aware of any changes in the structure of pricing.
              </li>
              <li>
                3.10. Any questions about these Terms of Use, the practices of
                Union App, or your dealings with us please contact us at
                support@unionmobilityapp.com
              </li>
            </ul>
            <h6 className="sub-to-sub-title">4. Accounts </h6>
            <ul className="under-list no-order">
              <li>
                4.1. Once a Driver is approved as a Driver he/she will be
                provided with an account.
              </li>
              <li>
                4.2. When registering as a Driver and creating an Account, the
                information the Driver provides must be accurate and complete.
                If any of the information changes at a later date, it is the
                Driver's responsibility to ensure that their Account is kept
                up-to-date. Union App shall undertake to ensure that the data is
                kept up-to-date and this may be reviewed regularly to ensure its
                accuracy.
              </li>
              <li>
                4.3. It is the responsibility of the Driver to protect their
                account details and ensure that no one else gains access. Any
                unauthorized access to a Driver’s account through the driver’s
                device shall be the responsibility of the Driver and the Driver
                shall be liable for any resulting financial loss. If a Driver
                believes their Account is being used without their permission,
                please contact Us immediately on the Union App Customer Care
                Line. Union App will not be liable for any unauthorized use of
                any Account.
              </li>
              <li>
                4.4. A Driver must not use any other Driver’s Account on any
                Union App.
              </li>
              <li>
                4.5. Any personal information provided in a Driver's Account
                will be collected, used, and held in accordance with the rights
                and obligations under the law.
              </li>
              <li>
                4.6. Union App reserves the right to suspend or deactivate a
                Driver’s account at any time.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">5. Cashless Earnings </h6>
            <ul className="under-list no-order">
              <li>
                5.1 The Union App enables Drivers to monitor their earnings from
                the Union App. All balances due from Union App to the Driver
                will be clearly stated in the Union App.
              </li>
              <li>
                5.2. We offer Drivers a range of options for how and when they
                wish to receive the settlement for their earnings. We will
                endeavour to ensure that all payments are made as and when
                agreed between the Driver and Us although these may be subject
                to delays that are outside Our control. Any Driver who believes
                that they have not received the correct payment should contact
                the Union App Support Desk immediately. We reserve the right to
                make any corrections to future earnings in the event of an
                overpayment by Union Boda.{" "}
                <b>
                  {" "}
                  We reserve the right to charge Drivers a withdrawal fee for
                  the internal and external costs of making payments to Drivers.
                </b>
              </li>
              <li>
                5.3. Drivers may be offered the opportunity to use their
                earnings to make purchases from us or third-party Service
                Providers. In such cases it is the responsibility of the Driver
                to check all transactions before approving and where necessary
                to contact the Union App Customer Care Desk.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">6. Platform fees </h6>
            <ul className="under-list no-order">
              <li>
                6.1. Union App may from time to time charge you a fee for using
                its platform to provide services. These will be clearly
                communicated to you at the time of onboarding as well as any
                other time during your use of the platform.
              </li>
              <li>
                6.2. All fees above, may from time to time be subject to change,
                and where so, management shall make effective communication to
                the drivers.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">7. Revenue and fare Breakdown</h6>
            <p>
              The base distance for the minimum fare charge applies within a 5km
              radius as determined or calculated by the platform's mapping and
              geofencing algorithms.
            </p>
            {/* terms and conditions table view */}
            <table className="table table-bordered mt-3 table-responsive d-block">
              <thead>
                <tr>
                  <th scope="col">Product Name</th>
                  <th scope="col">Union Boda</th>
                  <th scope="col">Union Car</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={3}>Driver Enrollment and Subscription fees</td>
                </tr>
                <tr>
                  <td colSpan={2}>Driver KYC Verification</td>
                  <td>UGX5,000 per application</td>
                </tr>
                <tr>
                  <td>Weekly Platform access Subscription fees</td>
                  <td>UGX5,000</td>
                  <td>UGX20,000</td>
                </tr>
                <tr>
                  <td colSpan={3}>Trip fare estimates</td>
                </tr>
                <tr>
                  <td>Base fare / Minimum fare</td>
                  <td>UGX2,000</td>
                  <td>UGX10,000</td>
                </tr>
                <tr>
                  <td>Per Minute fare</td>
                  <td>UGX100</td>
                  <td>UGX200</td>
                </tr>
                <tr>
                  <td>Per KM fare</td>
                  <td>UGX600</td>
                  <td>UGX1,000</td>
                </tr>
                <tr>
                  <td colSpan={3}>Passenger fee estimated</td>
                </tr>
                <tr>
                  <td colSpan={2}>Cash Rides</td>
                  <td>Zero fees</td>
                </tr>
                <tr>
                  <td colSpan={2}>Cashless ride transaction fees</td>
                  <td>+3.5% of the estimated ride total</td>
                </tr>
                <tr>
                  <td colSpan={2}>Withdraw fees (Paid by Rider/Driver)</td>
                  <td>-5% of the transaction total</td>
                </tr>
              </tbody>
            </table>
            {/* terms and conditions table view */}
            <p>
              Additional premiums may apply for specific distances and hours of
              the day depending on demand, driver availability and external
              factors such as events, inclement weather and road construction.
            </p>
            <h6 className="sub-to-sub-title">
              8. ‍Intellectual Property Rights
            </h6>
            <ul className="under-list no-order">
              <li>
                8.1. With the exception of User Content, all Content included on
                Our Site and the copyright and other intellectual property
                rights subsisting in that Content, unless specifically labelled
                otherwise, belongs to or has been licensed by us. All Content
                (including User Content) is protected by applicable Ugandan and
                international intellectual property laws and treaties.
              </li>
              <li>
                8.2. You may not reproduce, copy, distribute, sell, rent,
                sub-license, store, or in any other manner re-use Content from
                Our Application unless given express written permission to do so
                by Us.
              </li>
              <li>
                8.3. A User may:
                <ul className="under-list ps-5 ps-sm-0">
                  <li>
                    Access, view, and use Our Application in a web browser
                    (including any web browsing capability built into other
                    types of software or app);
                  </li>
                  <li>
                    Download Our Application (or any part of it) for caching;
                  </li>
                  <li>Print one copy of any page(s) from Our Application;</li>
                  <li>
                    Download extracts from the pages on Our Application; and
                  </li>
                  <li>
                    Save pages from Our Application for later and/or offline
                    viewing.
                  </li>
                </ul>
              </li>
              <li>
                8.4. Our status as the owner and author of the Content on Our
                Application (or that of identified licensors, as appropriate)
                must always be acknowledged.
              </li>
              <li>
                8.5. A User may not use any Content saved or downloaded from Our
                Application for commercial purposes without first obtaining a
                license from Us (or our licensors, as appropriate) to do so.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">9. ‍User Content</h6>
            <ul className="under-list no-order">
              <li>
                9.1. User Content on Our Site includes (but is not necessarily
                limited to) product reviews, comments, etc.
              </li>
              <li>
                9.2. An Account is required if a User wishes to submit User
                Content. Please refer to Clause 5 for more information.
              </li>
              <li>
                9.3. A User agrees to be solely responsible for their User
                Content. Specifically, they agree, represent, and warrant that
                they have the right to submit the User Content and that all such
                User Content will comply with Our Acceptable Usage Policy,
                detailed below in Clause 15.
              </li>
              <li>
                9.4. A User agrees to be liable to us and will, to the fullest
                extent permissible by law, indemnify us for any breach of the
                warranties given by us under sub-Clause 6.2.
              </li>
              <li>
                9.5. A User will be responsible for any loss or damage suffered
                by us as a result of such a breach.
              </li>
              <li>
                9.6. A User (or your licensors, as appropriate) shall retain
                ownership of their User Content and all intellectual property
                rights subsisting therein. When a User submits User Content they
                grant Us an unconditional, non-exclusive, fully transferable,
                royalty-free, perpetual, worldwide license to use, store,
                archive, syndicate, publish, transmit, adapt, edit, reproduce,
                distribute, prepare derivative works from, display, perform and
                sub-license the User Content for the purposes of operating and
                promoting Our Application. In addition, the User also grants
                Other Users the right to copy and quote their User Content
                within Our Application.
              </li>
              <li>
                9.7. We may reject, reclassify, or remove any User Content from
                Our Site where, in Our sole opinion, it violates Our Acceptable
                Usage Policy, or If We receive a complaint from a third party
                and determine that the User Content in question should be
                removed as a result.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">10. ‍Links to Our Application</h6>
            <ul className="under-list no-order">
              <li>
                10.1. A Driver may use or create a link to our Application
                provided that:
                <ul className="under-list ps-5">
                  <li>It is done in a fair and legal manner;</li>
                  <li>
                    It is not done in a manner that suggests any form of
                    association, endorsement or approval on Our part where none
                    exists;
                  </li>
                  <li>
                    A Driver does not use any logos or trademarks displayed on
                    Our Application without Our express written permission; and
                  </li>
                  <li>
                    A Driver does not use our Application in a manner that
                    causes damage to Our reputation or takes unfair advantage of
                    it.
                  </li>
                  <li>
                    Framing or embedding of Our Application on other websites is
                    not permitted without Our express written permission. Please
                    contact Us at support@unionmobilityapp.com for further
                    information.
                  </li>
                </ul>
              </li>
              <li>
                10.2. A Driver shall not link to Our Application from any other
                site the main content of which contains material that:
                <ul className="under-list ps-5">
                  <li>
                    is sexually explicit; obscene, deliberately offensive,
                    hateful, or otherwise inflammatory;
                  </li>
                  <li>promotes violence;</li>
                  <li>promotes or assists in any form of unlawful activity;</li>
                  <li>
                    discriminates against, or is in any way defamatory of, any
                    person, group, or class of persons, race, sex, religion,
                    nationality, color, political opinion, disability, sexual
                    orientation, or age;
                  </li>
                  <li>
                    Is intended or is otherwise likely to threaten, harass,
                    annoy, alarm, inconvenience, upset, or embarrass another
                    person;
                  </li>
                  <li>
                    Is calculated or is otherwise likely to deceive another
                    person;
                  </li>
                  <li>
                    Is intended or is otherwise likely to infringe (or threaten
                    to infringe) another person’s privacy;
                  </li>
                  <li>
                    Misleadingly impersonates any person or otherwise
                    misrepresents the identity or affiliation of a particular
                    person in a way that is calculated to deceive (obvious
                    parodies are not included in this definition provided that
                    they do not fall within any of the other provisions;
                  </li>
                  <li>
                    Implies any form of affiliation with Us where none exists;
                  </li>
                  <li>
                    infringes, or assists in the infringement of, the
                    intellectual property rights (including, but not limited to,
                    copyright, trademarks, and database rights) of any other
                    party; or
                  </li>
                  <li>
                    Is made in breach of any legal duty owed to a third party
                    including, but not limited to, contractual duties and duties
                    of confidence.
                  </li>
                </ul>
              </li>
              <li>
                10.3. The content restrictions in sub-Clause 10.6 do not apply
                to content submitted to sites by other users or drivers provided
                that the primary purpose of the site accords with the provisions
                of sub-Clause 10.6. A User, for example, is not prohibited from
                posting links on general-purpose social networking sites merely
                because another user may post such content. A Driver, however,
                is prohibited from posting links on websites that focus on or
                encourage the submission of such content from users.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">11. ‍Links to Other Sites</h6>
            <p>
              Links to other sites may be included in our Application. Unless
              expressly stated, these sites are not under Our control. We
              neither assume nor accept responsibility or liability for the
              content of third-party sites. The inclusion of a link to another
              site on Our Application is for information only and does not imply
              any endorsement of the sites themselves or of those in control of
              them.
            </p>
            <h6 className="sub-to-sub-title">12. ‍Disclaimers</h6>
            <ul className="under-list no-order">
              <li>
                12.1. Nothing on Our website constitutes advice on which a
                Driver shall rely. It is provided for general information
                purposes only.
              </li>
              <li>
                12.2. Insofar as is permitted by law, we make no representation,
                warranty, or guarantee that Our Application will meet your
                requirements, not infringe on the rights of third parties, be
                compatible with all software and hardware, or that it be secure.
              </li>
              <li>
                12.3. We make reasonable efforts to ensure that the Content on
                Our Application is complete, accurate, and up-to-date. We do
                not, however, make any representations, warranties, or
                guarantees (whether express or implied) that the Content is
                complete, accurate, or up-to-date. Please note that this
                exception does not apply to information concerning services for
                sale through Our Site.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">13. Our Liability</h6>
            <ul className="under-list no-order">
              <li>
                13.1. To the fullest extent permissible by law, We accept no
                liability to any Driver for any loss or damage, whether
                foreseeable or otherwise, in contract, tort (including
                negligence), for breach of statutory duty, or otherwise, arising
                out of or in connection with the use of (or inability to use)
                Our Application or the use of or reliance upon any Content
                (including User Content) included on Our Application.
              </li>
              <li>
                13.2. To the fullest extent permissible by law, we exclude all
                representations, warranties, and guarantees (whether express or
                implied) that may apply to Our Application or any Content
                included in Our Application.
              </li>
              <li>
                13.3. Our Application is intended for non-commercial use only.
                If you are a business user, we accept no liability for loss of
                profits, sales, business, or revenue; loss of business
                opportunity, goodwill, or reputation; loss of anticipated
                savings; business interruption; or for any indirect or
                consequential loss or damage.
              </li>
              <li>
                13.4. Reasonable skill and care shall be exercised to ensure
                that Our Application is free from viruses and other malware.
                However, We accept no liability for any loss or damage resulting
                from a virus or other malware, a distributed denial of service
                attack, or other harmful material or event that may adversely
                affect your hardware, software, data, or other material that
                occurs as a result of your use of Our Application (including the
                downloading of any Content from it) or any other site referred
                to on Our Application.
              </li>
              <li>
                13.5. We neither assume nor accept responsibility or liability
                arising out of any disruption or non-availability of Our
                Application resulting from external causes including, but not
                limited to, ISP equipment failure, host equipment failure,
                communications network failure, natural events, acts of war, or
                legal restrictions and censorship.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">‍14. Acceptable Usage Policy</h6>
            <ul className="under-list no-order">
              <li>
                14.1. A Driver may only use Our Application in a manner that is
                lawful and that complies with the provisions of this Clause 14.
              </li>
              <li>
                14.2. A Driver must ensure that he or she complies fully with
                any and all local, national or international laws and/or
                regulations;
              </li>
              <li>
                14.3. A Driver shall Not use Our Application in any way, or for
                any purpose, that is unlawful or fraudulent; or for any purpose,
                that is intended to harm any person or persons in any way.
              </li>
              <li>
                14.4. We reserve the right to suspend or terminate access to Our
                Application if a user is in material breach of the provisions of
                this Clause 14 or any of the other provisions of these Terms of
                Use. Specifically, we may take one or more of the following
                actions:
                <ul className="under-list ps-5">
                  <li>
                    suspend, whether temporarily or permanently, your Account
                    and/or your right to access Our Site;
                  </li>
                  <li>
                    remove any Driver Content submitted by a Driver that
                    violates this Acceptable Usage Policy;
                  </li>
                  <li>issue you with a written warning;</li>
                  <li>
                    take legal proceedings against you for reimbursement of any
                    and all relevant costs on an indemnity basis resulting from
                    your breach;
                  </li>
                  <li>take further legal action against you as appropriate;</li>
                  <li>
                    disclose such information to law enforcement authorities as
                    required or as We deem reasonably necessary; and/or
                  </li>
                  <li>
                    any other actions which We deem reasonably appropriate (and
                    lawful).
                  </li>
                </ul>
              </li>
              <li>
                14.5. We hereby exclude any and all liability arising out of any
                actions (including, but not limited to those set out above) that
                We may take in response to breaches of these Terms of Use.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">
              ‍15. Changes to these Terms of Use
            </h6>
            <p>
              We may alter these Terms of Use at any time. If we do so, details
              of the changes will be highlighted at the top of this page and a
              prompt may pop up at the time of your next usage of our
              application after such changes have been made. Any such changes
              will become binding on the user upon first use of Our Application
              after the changes have been implemented. A User is therefore
              advised to check this page from time to time to acquaint
              themselves with any new changes that may have been affected.
            </p>
            <h6 className="sub-to-sub-title">‍16. Contacting Us</h6>
            <p>
              To contact Us, please email Us at{" "}
              <a href="mailto:support@unionmobilityapp.com">
                support@unionmobilityapp.com
              </a>{" "}
              or Phone: <a href="tel:03910252538">03910252538</a> or use any of
              the methods provided on Our contact page at
              www.unionmobilityapp.com.
            </p>
            <h6 className="sub-to-sub-title">‍17. Communications from Us</h6>
            <ul className="under-list no-order">
              <li>
                17.1. By signing up for an Account a Driver agrees to receive
                communications from Union Appor any Union Apppartner. Such
                notices may relate to matters including, but not limited to,
                service changes, changes to these Terms of Use, Our Terms of
                Sale, and changes to your Account.
              </li>
              <li>
                17.2. For questions or complaints about communications from Us,
                please contact Us at{" "}
                <a href="mailto:support@unionmobilityapp.com">
                  support@unionmobilityapp.com
                </a>{" "}
                or via our Phone at <a href="tel:03910252538">03910252538</a>.
              </li>
            </ul>
            <h6 className="sub-to-sub-title">‍18. Law and Jurisdiction</h6>
            <ul className="under-list no-order">
              <li>
                18.1. These Terms and Conditions and the relationship between
                the User and Us (whether contractual or otherwise) shall be
                governed by, and construed in accordance with the laws of Uganda
                in which the Application is licensed and the goods or services
                available in the Application are provided.
              </li>
              <li>
                18.2. If a User is a consumer, any dispute, controversy,
                proceedings, or claim between him or her and Us relating to
                these Terms and Conditions, or the relationship between him or
                her and Us (whether contractual or otherwise) shall be subject
                to the jurisdiction of the courts of the country in which the
                Application is licensed and in which the goods or services
                available in the Application are provided.
              </li>
              <li>
                18.3. If a User is a business, any disputes concerning these
                Terms and Conditions, the relationship between the User and Us,
                or any matters arising therefrom or associated therewith
                (whether contractual or otherwise) shall be subject to the
                jurisdiction of the courts of the country in which the
                Application is licensed and in which the goods or services
                available in the Application are provided.
              </li>
            </ul>
          </div>
        </Container>
      </section>
    </>
  );
};
export default TermCondition;
